import {put,takeEvery} from 'redux-saga/dist/redux-saga-effects-npm-proxy.esm';

import {TYPES as USER_FRIEND_REQUEST_TYPE} from '../creators/user.friendRequest';

export function* updateSuccess(action) {
    try {
        yield put({type: "USER_FRIENDS_REQUEST_UPDATE", data : action.payload});
        yield put({type: "USER_FRIENDS_ADD", data : action.payload});
    } catch (error) {

    }
}

export function* watchFriendRequest() {
    yield takeEvery(USER_FRIEND_REQUEST_TYPE.UPDATE_SUCCESS, updateSuccess);
}

export default watchFriendRequest;

